
let toastRef = null;
export const setToastRef = (ref) => {
  toastRef = ref;
};
export const showToast = (options) => {
  if (toastRef && typeof toastRef.show === "function") {
    toastRef.show(options);
  }
};
